import type { AdminSelfServeSignup } from '../../api';

/**
 * The automatic setup steps of a self-serve sign-up (SELF_SERVE_STEPS, piece 4), in the words Trace Admin shows for
 * the step that failed. Typed by the contract's step list, so a new step cannot ship without its words.
 */
export const SELF_SERVE_STEP_LABELS: Readonly<
  Record<NonNullable<AdminSelfServeSignup['failedStep']>, string>
> = {
  organization: 'Create the organization',
  identity_provider: 'Link the sign-in organization',
  founder: 'Add the founder as owner',
  contract: 'Sign the trial contract',
  payment_method: 'Attach the saved card',
  modules: 'Switch on the chosen modules',
  enterprise: 'Set up Trace Enterprise',
};
